module.exports = __webpack_public_path__ + "static/img/icon zt wt02.65f31888.svg";